import { CSSInterpolation, Theme } from '@mui/material';

export default function IconButton({ palette }: Theme) {
  const bottomRectangleCss: CSSInterpolation = {
    ':after': {
      content: '""',
      backgroundColor: palette.primary.main,
      position: 'absolute',
      bottom: -4,
      left: '30%',
      height: 4,
      width: '40%',
    },
  };

  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          marginTop: 1,
          marginBottom: 1,
          width: '3.18rem',
          height: '3.18rem',
          padding: 0.5,
          '&:focus': {
            outline: `1px solid ${palette.primary.main}`,
            backgroundColor: 'none',
          },
          '&:not(.brand-icon):hover': {
            ...bottomRectangleCss,
            color: palette.primary.main,
            backgroundColor: 'inherit',
          },
          '&.selected': {
            ...bottomRectangleCss,
          },
        },
        sizeSmall: {
          width: '2rem',
          height: '2rem',
        },
      },
    },
  };
}
